import { useState, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

// Empty defaults - admin must fill in actual values
const defaults = {
  phone: '',
  email: '',
  address_line1: '',
  address_line2: '',
  hero_title: '',
  hero_subtitle: '',
  hero_description: '',
  youtube_url: '',
  facebook_url: '',
  instagram_url: '',
};

let cached = null;

export const useSiteContent = () => {
  const [content, setContent] = useState(cached || defaults);

  useEffect(() => {
    if (cached) { setContent(cached); return; }
    axios.get(`${API}/api/site-content`)
      .then(res => { cached = { ...defaults, ...res.data }; setContent(cached); })
      .catch(() => setContent(defaults));
  }, []);

  return content;
};
